import { create } from 'zustand';

/**
 * [#916] Estado GLOBAL do estabelecimento ativo da sessão — substitui o
 * filtro local que cada tela (Agenda, CRM, Dashboard, etc.) mantinha com seu
 * próprio `<SeletorEstabelecimento>`. `null` = "Todas" (`X-Estabelecimento-Id`
 * ausente, ADR-069 §13.3 — já significa "todos os permitidos").
 *
 * Quem ESCREVE aqui é só o `<SeletorEstabelecimento>` único, montado no
 * `AppShell` perto do nome do tenant — ele já resolve sozinho single-unit
 * transparente, aplicação do estabelecimento preferencial (AB#295) e
 * revalidação contra `estabelecimentos_permitidos` (D10 #915). Páginas
 * migradas só LEEM `estabelecimentoAtivoId` — nunca chamam `definir`
 * diretamente nem renderizam seu próprio `<SeletorEstabelecimento>`.
 *
 * Sem `persist`: a escolha "de verdade" vive no backend
 * (`Usuario.estabelecimento_preferencial_id`, `PATCH /auth/perfil`) e é
 * restaurada no boot via `useEstabPreferencial()` dentro do próprio
 * `SeletorEstabelecimento`. Espelhar em `localStorage` aqui criaria uma
 * segunda fonte de verdade que pode divergir entre abas/dispositivos.
 */
interface EstabelecimentoAtivoState {
  estabelecimentoAtivoId: number | null;
  definir: (id: number | null) => void;
  limpar: () => void;
}

export const useEstabelecimentoAtivoStore = create<EstabelecimentoAtivoState>((set) => ({
  estabelecimentoAtivoId: null,
  definir: (id) => set({ estabelecimentoAtivoId: id }),
  limpar: () => set({ estabelecimentoAtivoId: null }),
}));
